var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui grid container"},[_c('inventory-overview',{staticClass:"sixteen wide column",staticStyle:{"margin-bottom":"0"}}),_c('inventory-input',{staticClass:"eight wide column"}),_c('inventory-output',{staticClass:"eight wide column"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }